export function htmlToText(htmlText: string): string {
    const tempDivElement = document.createElement('div');
    // Set the HTML content with the given value
    tempDivElement.innerHTML = htmlText;

    // Retrieve the text property of the element
    return tempDivElement.textContent || tempDivElement.innerText || '';
}


export function htmlToFormattedText(htmlText: string, removeBrTag: boolean = true): string {
    const div = document.createElement('div');
    div.innerHTML = htmlText;
    div.querySelectorAll('br').forEach(br => br.replaceWith(removeBrTag ? ' ' :'\n'));

    // Add newline after block elements
    const blockTags = 'li, ul, ol, h1, h2, h3, h4, h5, h6, p';
    div.querySelectorAll(blockTags).forEach(el => {
        el.insertAdjacentText('afterend', '\n');
    });

    return div.textContent || div.innerText || '';
}
